import React, { FunctionComponent } from 'react'
import GeofenceList from './GeofenceList/GeofenceList'

interface IProps {
  userId: number
}

const Geofences: FunctionComponent<any> = (props: IProps) => {

  const { userId } = props

  return <GeofenceList userId={userId} />
}

export default Geofences
